import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    console.log("mutationobserver init")
    const type = this.element.dataset.type
    const show = (sel) => document.querySelectorAll(sel).forEach(el => {
      el.style.display = el.tagName === "SPAN" ? "inline" : "block";
    });
    const hide = (sel) => document.querySelectorAll(sel).forEach(el => el.style.display = 'none');
    if (type === "paper") {
      show(".deck-price-paper"); hide(".deck-price-online");
    } else if (type === "online") {
      hide(".deck-price-paper"); show(".deck-price-online");
    }
  }
}
